module.exports = {
      id: "humoursatire-entertainment-usage",
      viewBox: "0 0 77 77",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#humoursatire-entertainment",
      toString: function () {
        return this.url;
      }
    }